/* ══════════════════════════════════════════════════════════════════
   集合页运行时 —— 筛选、排序、加载更多。

   做法是**局部替换**：勾一个筛选就按表单拼出 URL，取回同一页的 HTML，
   只把结果区和筛选栏换掉，地址栏同步更新。
   不做前端过滤：数量、可选值、排序全部是 Shopify 按当前查询算好的，
   前端自己算一份早晚和后端对不上。

   没有 JS 也能用：表单是原生 GET、chip 是真链接、分页是真链接。
   这里只是把整页跳转换成局部替换。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function init(root) {
    var section = root.querySelector('.eb-section--collection') || root;
    if (!section || section.dataset.colReady === '1') return;
    section.dataset.colReady = '1';

    var form = section.querySelector('[data-facet-form]');
    var results = section.querySelector('[data-results]');
    var drawer = section.querySelector('[data-facet-drawer]');
    if (!results) return;

    var pending = null;

    /* ── 折叠组 ── */
    section.addEventListener('click', function (e) {
      var head = e.target.closest('[data-facet-toggle]');
      if (!head) return;
      var group = head.parentNode;
      var closed = group.classList.toggle('is-closed');
      head.setAttribute('aria-expanded', closed ? 'false' : 'true');
    });

    /* ── 抽屉：走 EB.overlay，滚动锁和焦点陷阱全站共用一套 ── */
    if (drawer) {
      var releaseFocus = null;
      if (window.EB && EB.overlay) {
        EB.overlay.register('collection-filters', {
          onOpen: function () {
            drawer.classList.add('is-open');
            releaseFocus = EB.trapFocus(drawer.querySelector('.eb-fdrawer__panel'));
          },
          onClose: function () {
            drawer.classList.remove('is-open');
            if (releaseFocus) releaseFocus();
          }
        });
      }
      section.addEventListener('click', function (e) {
        if (e.target.closest('[data-facet-open]')) {
          if (window.EB && EB.overlay) EB.overlay.open('collection-filters');
          else drawer.classList.add('is-open');
        }
        if (e.target.closest('[data-facet-close]')) {
          if (window.EB && EB.overlay) EB.overlay.close('collection-filters');
          else drawer.classList.remove('is-open');
        }
      });
    }

    /* ── 取数并替换 ── */
    function urlFromForm() {
      var params = new URLSearchParams(new FormData(form));
      /* 空值不进地址栏：`?filter.v.price.gte=` 这种空参数会让 URL 越点越长 */
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      var qs = clean.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    function swap(url, opts) {
      opts = opts || {};
      if (pending) pending.abort();
      pending = new AbortController();
      section.classList.add('is-loading');

      return fetch(url, { signal: pending.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newResults = doc.querySelector('[data-results]');
          if (!newResults) { window.location.href = url; return; }

          if (opts.append) {
            var grid = results.querySelector('[data-grid]');
            var newGrid = newResults.querySelector('[data-grid]');
            if (grid && newGrid) grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
            var more = results.querySelector('[data-more]');
            var newMore = newResults.querySelector('[data-more]');
            if (more) { if (newMore) more.replaceWith(newMore); else more.remove(); }
          } else {
            results.innerHTML = newResults.innerHTML;
            /* 数量和可选值会随筛选变，所以筛选栏也要一起换回来 */
            ['[data-facet-form]', '.eb-toolbar', '[data-results-count]', '.eb-fdrawer__head', '.eb-fdrawer__foot']
              .forEach(function (sel) {
                var cur = section.querySelector(sel), next = doc.querySelector(sel);
                if (cur && next) cur.innerHTML = next.innerHTML;
              });
            form = section.querySelector('[data-facet-form]');
            window.history.pushState({}, '', url);
          }

          if (window.EB && EB.motion) EB.motion.mount(section);
          if (window.EB) EB.emit('collection:updated', { url: url });
        })
        .catch(function (err) { if (err.name !== 'AbortError') window.location.href = url; })
        .finally(function () { section.classList.remove('is-loading'); pending = null; });
    }

    /* ── 勾选即生效。价格输入用 debounce，别每敲一个数字发一次请求。 ── */
    if (form) {
      var debounced = (window.EB && EB.debounce)
        ? EB.debounce(function () { swap(urlFromForm()); }, 450)
        : function () { swap(urlFromForm()); };

      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') debounced();
        else swap(urlFromForm());
      });
      form.addEventListener('input', function (e) {
        if (e.target.type === 'number') debounced();
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); swap(urlFromForm()); });
    }

    /* 排序的 <select> 用 form 属性挂在筛选表单上，所以上面的 change 已经接住了；
       没有筛选栏时（enable_filtering 关掉）它自己走一遍。 */
    var sort = section.querySelector('[data-sort]');
    if (sort && !form) {
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        swap(u.pathname + u.search);
      });
    }

    /* ── 链接（chip 的 ×、Clear all、加载更多）── */
    section.addEventListener('click', function (e) {
      var more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        more.classList.add('is-loading');
        swap(more.href, { append: true });
        return;
      }
      var chip = e.target.closest('.eb-chip[href]');
      if (chip) { e.preventDefault(); swap(chip.href); }
    });

    window.addEventListener('popstate', function () {
      swap(window.location.pathname + window.location.search);
    });
  }

  function mountAll(root) {
    (root || document).querySelectorAll('.eb-section--collection').forEach(function (el) { init(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  else mountAll();
  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
})();
